import { render } from "./App.vue?vue&type=template&id=df2c47ce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=df2c47ce&lang=css"

import exportComponent from "/home/merlyn/Working/bili-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__